import { FeeHelper } from '..';

export const useFee = () => {
	let feeHelper = new FeeHelper();
	return {
		feeHelper,
		activeFee: feeHelper.active()
	};
};
